import React from 'react';

import offerEnvelope from 'images/referral/offer_envelope.svg';

import LinkCopy from '@components/LinkCopy';
import TIModal from '@components/TIModal';

import styles from './styles.module.scss';

const Modal = ({
  isOpen,
  onClose,
  referralUrl,
}: {
  isOpen: boolean;
  onClose: () => void;
  referralUrl: string;
}) => {
  return (
    <TIModal
      isOpen={isOpen}
      onClose={onClose}
      parentClass={styles.referralModal}
      customHeader={true}
    >
      <div className={styles.topHeaderContainer}>
        <div className={styles.topHeader}>
          <div className={styles.header}>
            The Information is better when friends &#38; colleagues <strong>read together</strong>
          </div>
        </div>
        <button className="close-button" onClick={onClose}></button>
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.giftContainer}>
          <img src={offerEnvelope} width={25} height={25} />
        </div>
        <div className={styles.intro}>
          As a benefit of your subscription, you can give 25% off access to The Information.
        </div>
        <div className={styles.subIntro}>
          Share this custom offer link with friends and colleagues.
        </div>
        <div className={styles.customLink}>Your custom invite link</div>
        <div className={styles.linkWrapper}>
          <LinkCopy
            clipboardLink={referralUrl}
            customClass={styles.linkContainerOverride}
            trackingProps={{
              'ahoy-name': 'Referral Modal - Click On Copy Referral Link',
              location: 'referral_modal',
              name: 'copy_referral_link',
            }}
          />
        </div>
      </div>
    </TIModal>
  );
};

export default Modal;
